import { useEffect, useRef } from "react"

export default function Confetti({ active, onComplete }) {
    const canvasRef = useRef(null)

    useEffect(() => {
        if (!active) {
            return
        }

        const canvas = canvasRef.current
        const ctx = canvas.getContext("2d")
        canvas.width = window.innerWidth
        canvas.height = window.innerHeight

        const particles = []
        const colors = ["#f08080", "#42A5F5", '#6c5ce7', '#45b7d1']

        // Create particles
        for (let i = 0; i < 150; i++) {
            particles.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height - canvas.height,
                r: Math.random() * 6 + 2,
                d: Math.random() * 150,
                color: colors[Math.floor(Math.random() * colors.length)],
                tilt: Math.random() * 10 - 10,
                tiltAngle: 0,
                tiltAngleIncrement: Math.random() * 0.07 + 0.05,
            })
        }

        let animationFrame

        function draw() {
            ctx.clearRect(0, 0, canvas.width, canvas.height)

            particles.forEach((p, i) => {
                ctx.beginPath()
                ctx.lineWidth = p.r / 2
                ctx.strokeStyle = p.color
                ctx.moveTo(p.x + p.tilt + p.r, p.y)
                ctx.lineTo(p.x + p.tilt, p.y + p.tilt + p.r)
                ctx.stroke()

                // Update
                p.tiltAngle += p.tiltAngleIncrement
                p.y += (Math.cos(p.d) + 3 + p.r / 2) / 2
                p.tilt = Math.sin(p.tiltAngle) * 15

                if (p.y > canvas.height) {
                    particles.splice(i, 1)
                }
            })

            if (particles.length > 0) {
                animationFrame = requestAnimationFrame(draw)
            } else {
                onComplete?.()
            }
        }

        draw()

        return () => {
            if (animationFrame) {
                cancelAnimationFrame(animationFrame)
            }
            onComplete?.()
        }
    }, [active, onComplete])

    if (!active) return null

    return <canvas ref={canvasRef} className="fixed inset-0 pointer-events-none z-50" />
}
